import {
  AnalyticsOutlined,
  AssessmentOutlined,
  ChatBubbleOutline,
  Message,
  MoreVert,
  TroubleshootOutlined,
} from "@mui/icons-material";
import {
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useTranslation } from "_metronic/i18n/language";
import Loading from "app/pages/home/components/Loading";
import { AnanseApiService } from "app/services/Ananse/AnanseApiService";
import { PatientAccountType } from "app/types";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { formatedDate } from "utils";
import { titlePage } from "utils/titlepage";
import BackWithTitle from "./components/BackWithTitle";
import DataTable from "./components/DataTable";
import ModalResult from "./components/ModalResult";
import DetailResultForm from "./DetailResultForm";

interface ParamsI {
  id: number | undefined;
  name: string;
}

interface ResultsI {
  testResultId: any;
  quizAnswer: Array<any>;
  anamneseResultId?: any;
}

type ResultListingProps = {
  account: number;
};
const ResultListing = ({ account }: ResultListingProps) => {
  const translate = useTranslation();
  const api = new AnanseApiService();
  // const params: any = useParams();
  // const account: ParamsI | undefined = params;
  const endPoint = `/quiz/accountid/${account}`;
  const [loading, setLoading] = useState(false);
  const [isOpenDetailResult, setOpenDetailResult] = useState(false);
  const [results, setResults] = useState<Array<ResultsI>>([]);
  const [anamneses, setAnamneses] = useState<Array<ResultsI>>([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [itemData, setItemData] = React.useState(null);
  const [itIsAnamnese, setIsItAnamnese] = React.useState(false);
  const [accountSelected, setAccountSelected] = React.useState(
    {} as PatientAccountType,
  );
  const [resultDetails, setResultDetails] = React.useState<any[]>([]);
  const [quizzes, setQuizzes] = React.useState<any[]>([]);
  const [openedCompositionMenu, setOpenedCompositionMenu] = useState<boolean>(
    false,
  );

  const [anchorEl, setAnchorEl] = React.useState<{
    element: HTMLElement | null;
    row: any | null;
  }>({ element: null, row: null });
  const open = Boolean(anchorEl.element);
  const handleClick = (event: React.MouseEvent<HTMLElement>, rowData: any) => {
    event.stopPropagation();
    setAnchorEl({ element: event.currentTarget, row: rowData });
    setOpenedCompositionMenu(true);
  };
  const handleClose = () => {
    setAnchorEl({ element: null, row: null });
  };

  const loadRecords = async () => {
    setLoading(true);
    try {
      getAccount(account);
      const result = await api.makeHttpRequest({ url: endPoint });

      const sortedResult = result.sort(
        (a: any, b: any) =>
          new Date(b.quizAnswer[0].initDate).getTime() -
          new Date(a.quizAnswer[0].initDate).getTime(),
      );

      const filterAnamnese = sortedResult.filter((ai: ResultsI) =>
        ai.quizAnswer.some((v: any) => v.rightAnswer === "N/A"),
      );

      const filterResults = sortedResult.filter((ai: ResultsI) =>
        ai.quizAnswer.some((v: any) => v.rightAnswer !== "N/A"),
      );

      setAnamneses(filterAnamnese);
      setResults(filterResults);
      const responseQuizzesAll = await api.makeHttpRequest({
        url: `/quiz?PerPage=1000&Page=1`,
      });
      console.log("responseQuizzesAll", responseQuizzesAll);
      setQuizzes(responseQuizzesAll.data);
    } catch (error) {
      Swal.fire(
        translate("defaultMessages.error"),
        translate("defaultMessages.loadData"),
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRecords();
  }, []);

  const getAccount = async (
    accountId: number | undefined,
  ): Promise<PatientAccountType | any> => {
    try {
      const response: PatientAccountType = await api.makeHttpRequest({
        url: `/account/${accountId}`,
      });
      setAccountSelected(response);
    } catch (error) {
      console.error("error getAccount: ", error);
    }
  };

  const headColumns = [
    { id: "none", label: translate("screens.dashboard.action") },
    { id: "createdAt", label: translate("screenApp.results.examDate") },
    {
      id: "quizName",
      label: translate("screens_quiz_list_name"),
    },
    {
      id: "testResultId",
      label: translate("screenApp.results.numberTest"),
    },
    { id: "doctor", label: translate("screenApp.results.title") },
    { id: "email", label: translate("screens.login.email") },
    { id: "macAddress", label: translate("screens.device.title") },
  ];

  const gerarResultado = (value: any) => {
    setItemData(value);
    setIsItAnamnese(false);
    setOpenModal(true);
  };

  const gerarAnamnese = (item: any) => {
    const filterAnamnese: any = anamneses?.find(
      value => value?.testResultId === item?.quizAnswer[0]?.anamneseResultId,
    );
    setItemData(filterAnamnese);
    setIsItAnamnese(true);
    setOpenModal(true);
  };

  const onOpenDetailResult = (item: any) => {
    setItemData(item);
    setOpenDetailResult(true);
  };

  const getResultDetails = useCallback(async () => {
    const { total } = await api.makeHttpRequest({
      method: "GET",
      url: `/quizanswerdetails`,
    });
    const { data } = await api.makeHttpRequest({
      method: "GET",
      url: `/quizanswerdetails?PerPage=${total}`,
    });
    setResultDetails(data);
    return data.length;
  }, [isOpenDetailResult]);

  useEffect(() => {
    getResultDetails();
  }, [getResultDetails]);

  const renderMenu = () => {
    if (!anchorEl.row) return null;

    const row = anchorEl.row;
    const filterRD = resultDetails.find(
      r => r.testResultId === row.testResultId,
    );

    const openDetailResultReport = () => {
      gerarResultado(row);
      handleClose();
    };

    return (
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl.element}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            onOpenDetailResult(row);
            handleClose();
          }}
        >
          <ListItemIcon>
            {filterRD ? (
              <Message fontSize="small" />
            ) : (
              <ChatBubbleOutline fontSize="small" />
            )}
          </ListItemIcon>
          {translate("screenApp.anamnese.list.commentResults")}
        </MenuItem>
        <MenuItem onClick={openDetailResultReport}>
          <ListItemIcon>
            <AssessmentOutlined />
          </ListItemIcon>
          {translate("buttons_report")}
        </MenuItem>
        <Link
          to={`/admin/test/${row.testResultId}`}
          style={{ textDecoration: "none" }}
        >
          <MenuItem onClick={handleClose}>
            <ListItemIcon>
              <AnalyticsOutlined />
            </ListItemIcon>
            {translate("buttons_analysis_report")}
          </MenuItem>
        </Link>
        {row?.anamneseResultId && !!row?.anamneseResultId ? (
          <MenuItem
            onClick={() => {
              gerarAnamnese(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <TroubleshootOutlined />
            </ListItemIcon>
            {translate("screenApp.anamnese.list.viewAnamnese")}
          </MenuItem>
        ) : null}
      </Menu>
    );
  };

  const formatRows = (row: any, labelId: any) => {
    const filterRD = resultDetails.find(
      r => r.testResultId === row.testResultId,
    );

    const getQuizName = (quizId: string) => {
      const quiz = quizzes.find(q => q.quizId === quizId);
      return quiz ? quiz.name : "";
    };

    const openDetailResultReportDoubleClick = () => {
      if (openedCompositionMenu) {
        setOpenedCompositionMenu(false);
        return;
      }
      gerarResultado(row);
      handleClose();
    };

    return (
      <TableRow
        hover
        tabIndex={-1}
        key={row.testResultId}
        sx={{ cursor: "pointer" }}
        onClick={openDetailResultReportDoubleClick}
        onDoubleClick={openDetailResultReportDoubleClick}
      >
        <TableCell>
          <Tooltip
            title={translate("screens.dashboard.action")}
            placement="top"
            arrow
          >
            <IconButton
              id="composition-button"
              aria-controls={open ? "composition-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={event => handleClick(event, row)}
            >
              <MoreVert />
            </IconButton>
          </Tooltip>
          {open && renderMenu()}
        </TableCell>
        <TableCell align="inherit">
          {row.quizAnswer[0]?.createdAt
            ? formatedDate(row.quizAnswer[0]?.createdAt, true, true)
            : null}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {getQuizName(row.quizAnswer[0].quizId)}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {row.testResultId}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {row.quizAnswer[0]?.doctor}
        </TableCell>
        <TableCell id={labelId} align="inherit">
          {row.quizAnswer[0]?.email}
        </TableCell>
        <TableCell align="inherit">{row.quizAnswer[0]?.macAddress}</TableCell>
      </TableRow>
    );
  };

  React.useEffect(() => {
    titlePage(`${nameTitle} - ${translate("labels_admin")}`);
  }, [accountSelected?.name]);

  const nameTitle =
    translate("screenApp.anamnese.list.resultsOf") + accountSelected?.name;

  return (
    <div>
      <DetailResultForm
        open={isOpenDetailResult}
        setOpen={setOpenDetailResult}
        data={{ account: accountSelected }}
        result={isOpenDetailResult ? itemData : null}
        setResult={setItemData}
      />
      <ModalResult
        openModal={openModal}
        setOpenModal={setOpenModal}
        data={itemData}
        setData={setItemData}
        accountId={account}
        itIsAnamnesis={itIsAnamnese}
      />
      <Loading isLoading={loading} />
      <DataTable
        titleTable={<BackWithTitle title={nameTitle} />}
        headColumns={headColumns}
        rows={results}
        formatRows={formatRows}
        placeholderSearch={
          translate("screenApp.anamnese.list.search") +
          " " +
          translate("screenApp.results.numberTest")
        }
        loading={loading}
        onRefresh={loadRecords}
      />
    </div>
  );
};

export default ResultListing;
